import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import asyncComponent from "util/asyncComponent";

const Movimiento = ({match}) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/registroBajas`}/>
    <Route path={`${match.url}/registroBajas`} component={asyncComponent(() => import('./registroBajas/index'))}/>
    <Route path={`${match.url}/retiroTransferencias`} component={asyncComponent(() => import('./retiroTransferencias/index'))}/>
  </Switch>
);

export default Movimiento;
